// Copy builders that consume the strings contract. All pure — they map server
// codes / size data to shopper copy and never touch the DOM.
import type { SizeResultData } from "./types"
import type { Strings } from "./strings"

export function humanError(code: string, s: Strings) {
  return s.genError[code] || s.genErrorFallback
}

export function recommendationNote(data: SizeResultData, s: Strings) {
  const fitLabels: Record<string, string> = { tight: s.fitTight, regular: s.fitRegular, loose: s.fitLoose }
  const fit = data.fit ? fitLabels[data.fit] : undefined
  const confidence = data.overall_confidence ?? data.confidence ?? 0
  const confidenceLabel = confidence >= 0.8 ? s.confHigh : confidence >= 0.65 ? s.confMedium : s.confLimited
  const alternative = data.alternative_size ? s.alternativeAlso(data.alternative_size) : undefined
  return [ s.estimateBeta, fit, confidenceLabel, alternative ].filter(Boolean).join(" · ")
}

export function sizeUnknownMessage(reason: string | null | undefined, s: Strings) {
  return s.sizeReason[reason || ""] || s.sizeReasonFallback
}
